import Swiper from "swiper/bundle";

export default function aboutCompanySwiper (){
    let swiperContainer = document.querySelector('[data-about-company="swiper"]');

    if(swiperContainer){
        let currentNumber = document.querySelector('[data-about-company="current-page"]');
        let nextNumber = document.querySelector('[data-about-company="next-page"]');

        let swiper = new Swiper(swiperContainer, {
            modules: [],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 8,
            breakpoints: {
                992:{
                    direction: "vertical",
                    allowTouchMove: false,
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                }
            },
            pagination: {
                clickable: false,
                el: '[data-about-company="pagination"]',
            },
            on: {
                slideChange: function () {
                    let currentSlide = this.slides[this.activeIndex];
                    let nextSlide = this.slides[(this.activeIndex == (this.slides.length - 1))? 0 :this.activeIndex + 1];

                    let currentSlideNumber = currentSlide.querySelector('[data-about-company="number"]');
                    let nextSlideNumber = nextSlide.querySelector('[data-about-company="number"]');

                    currentNumber.innerHTML = currentSlideNumber.innerHTML;
                    nextNumber.innerHTML = nextSlideNumber.innerHTML;
                }
            }
        });
    }
}